module.exports = __webpack_public_path__ + "static/img/图层 22.9f1c270e.png";